import React from "react";
import { Container } from "../../styles/container";
import styled from "styled-components";
import CustomButton from "../CustomButton";
const Content = styled.div`
  margin: 40px 0px 0px;
  .campus {
    margin: 0 auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > .gpt_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    max-width: 800px;
    margin: 0 auto;

    .campus {
      flex: 0 0 calc(25% - 20px);
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 768px) {
    .gpt_container .campus {
      flex: 0 0 calc(50% - 20px);
    }
  }

  @media (max-width: 480px) {
    .gpt_container .campus {
      flex: 0 0 100%; // 1 per row
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;
const GptContent = () => {
  const gptButtons = [
    { title: "View SSB-GPT", link: "https://alpharegiment.com/ssb/gpt" },
    { title: "View CDS-GPT", link: "https://alpharegiment.com/cds/gpt" },
    { title: "View AFCAT-GPT", link: "https://alpharegiment.com/afcat/gpt" },
    { title: "View INET-GPT", link: "https://alpharegiment.com/inet/gpt" },
    { title: "View NDA-GPT", link: "https://alpharegiment.com/nda/gpt" },
    { title: "View Teacher-GPT", link: "https://alpharegiment.com/school/gpt" },
    { title: "View UPSC-GPT", link: "https://alpharegiment.com/upsc/gpt" },
  ];

  return (
    <Container>
      <Content>
        <h2 className="main_heading">
          Revolutionizing Education with Specialized AI Mentors: Our Vision for
          GPTs
        </h2>
        <p>
          At Alpha Regiment, we recognize the transformative power of Artificial
          Intelligence (AI) in education. AI has the potential to perform
          certain tasks more efficiently and effectively than humans, and we aim
          to harness this capability to support students in their academic
          journeys. Our vision is to create multiple specialized
          GPTs—intelligent AI mentors tailored to specific exams. These GPTs
          will act as personal mentors, available 24x7 to guide students,
          address their queries, and help them prepare comprehensively for their
          targeted exams.
        </p>
        <br />
        <h4>Tailored GPTs for Different Exams</h4>
        <br />
        <p>
          Each GPT is designed with a user interface (UI) and features that
          align with the specific requirements of the exam it supports. Here’s a
          glimpse of our existing and planned GPTs:
        </p>
        <br />
        <h4>SSB GPT: Your Personal Mentor for SSB Preparation</h4>
        <br />
        <p>
          SSB GPT is tailored for students preparing for the Services Selection
          Board (SSB) interviews. This AI mentor provides a classroom-like
          experience, offering dedicated spaces for:{" "}
        </p>

        <ul>
          <li>
            <strong>1. Group Discussions (GDs):</strong> Simulate real GD
            scenarios and receive feedback to improve communication and teamwork
            skills.
          </li>
          <li>
            <strong>2. Psychology Tests:</strong>
            Prepare for TAT, WAT, SRT, and SD with AI-driven guidance.
          </li>
          <li>
            <strong>3. Spoken English Practice:</strong>
            Enhance fluency and confidence for interviews and group tasks.
          </li>
          <li>
            <strong>4. Personal Interview Practice:</strong> Get personalized
            feedback and tips to excel in interviews.
          </li>
        </ul>
        <br />

        <h4>NDA GPT: The Ultimate Guide for NDA Aspirants</h4>
        <br />
        <p>
          For students preparing for the National Defence Academy (NDA) exam,
          NDA GPT offers a comprehensive preparation platform with features
          like:
        </p>
        <br />
        <ul>
          <li>
            <strong>1. Spoken English Practice:</strong>
            Tailored sessions to improve communication skills.
          </li>
          <li>
            <strong>2. Mathematics Support:</strong>
            Interactive problem-solving and concept clarification.
          </li>
          <li>
            <strong>3. General Studies (GS):</strong>
            AI-driven modules covering history, geography, current affairs, and
            more.
          </li>
          <li>
            <strong>4. Virtual Classrooms:</strong>A seamless environment for
            collaborative learning and discussions.
          </li>
        </ul>
        <br />

        <h4>AFCAT GPT and INET GPT</h4>
        <br />
        <p>
          These GPTs cater to aspirants of the Air Force Common Admission Test
          (AFCAT) and Indian Navy Entrance Test (INET). Each GPT includes:
        </p>
        <br />
        <ul>
          <li>
            <strong>1. Subject-Specific Guidance:</strong>
            Focused modules for reasoning, mathematics, and general awareness.
          </li>
          <li>
            <strong>2. Mock Tests and Analysis:</strong>
            Practice full-length tests with detailed performance analysis.
          </li>
          <li>
            <strong>3. Spoken English and Interview Prep:</strong>
            Boost confidence for verbal and interview rounds.
          </li>
        </ul>
        <br />

        <h4>Future Plans: Expanding the GPT Ecosystem</h4>
        <br />
        <p>
          We are actively working on launching additional GPTs to cover a
          broader spectrum of exams:
        </p>
        <br />
        <ul>
          <li>
            <strong>1. UPSC GPT:</strong>A mentor for UPSC aspirants, offering
            modules on optional subjects, essay writing, current affairs, and
            CSAT.
          </li>
          <li>
            <strong>2. SSC GPT:</strong>
            Tailored for Staff Selection Commission exams, with focused training
            in reasoning, quantitative aptitude, English, and GS.
          </li>
          <li>
            <strong>3. RRB GPT:</strong>
            Designed for Railway Recruitment Board exams, providing guidance in
            technical and non-technical categories.
          </li>
        </ul>
        <br />

        <h4>Key Features of Our GPTs</h4>
        <br />
        <ul>
          <li>
            <strong>1. 24x7 Availability:</strong> Your personal mentor is
            always ready to help, no matter the time.
          </li>
          <li>
            <strong>2. Custom UI and Interfaces:</strong>
            Each GPT is designed with tools and features specific to its target
            exam.
          </li>
          <li>
            <strong>3. Interactive Learning:</strong>
            Virtual classrooms, practice modules, and real-time feedback
            simulate a complete learning environment.
          </li>
          <li>
            <strong>3. Adaptive Support:</strong>
            AI-driven insights ensure personalized learning paths based on
            student performance.{" "}
          </li>
        </ul>
        <br />

        <h4>Our Commitment</h4>
        <br />
        <p>
          With this innovative ecosystem of specialized GPTs, we aim to redefine
          education and make quality preparation accessible to every aspirant.
          Whether you’re preparing for a competitive exam or seeking to improve
          specific skills, our GPTs provide the guidance and support you need to
          succeed.
        </p>
        <br />
        <div className="gpt_container">
          {gptButtons.map((btn, index) => (
            <CustomButton
              key={index}
              title={btn.title}
              width="180px"
              className="campus"
              onClick={() =>
                window.open(btn.link, "_blank", "noopener,noreferrer")
              }
            />
          ))}
        </div>
        <br />
        <br />
      </Content>
    </Container>
  );
};

export default GptContent;
